import Base from './Base';

class Entrega extends Base {

    constructor (token) {
        super(token);
        this.endpoint = 'contratos';
    }

    getInventarioListo( user_id ) {
        return  fetch(this.getUrlEndpoint("get-inventario-listo/"+user_id),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    retrieve( orderBy ) {
        return  fetch(this.getUrlEndpoint("retrieve/?orderBy="+orderBy),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    retrieveFilter( filter, orderBy, month, year ) {
        return  fetch(this.getUrlEndpoint("retrieve/?filter="+filter+"&orderBy="+orderBy+"&month="+month+"&year="+year),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    activateEmailCobranza(user_id,changer_id){
        return  fetch(this.getUrlEndpoint("email-cobranza/activate/"+user_id+'/'+changer_id),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    desactivateEmailCobranza(user_id,changer_id){
        return  fetch(this.getUrlEndpoint("email-cobranza/desactivate/"+user_id+'/'+changer_id),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    downloadXls(){
        return  this.baseUrl + this.endpoint + "/generate-xls/"
    }

    changeType( id , type ){
        return  fetch(this.getUrlEndpoint("change-type/"+id+'/'+type),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    getDeliveryData( user_id ) {
        return  fetch(this.getUrlEndpoint("get-delivery-data/"+user_id),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }
    
}

export default Entrega;